import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

/** Live `prefers-reduced-motion: reduce`. `false` on the server and on the first client render. */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const media = window.matchMedia(QUERY);
    const sync = () => setReduced(media.matches);
    sync();
    media.addEventListener('change', sync);
    return () => media.removeEventListener('change', sync);
  }, []);

  return reduced;
}

/** Non-reactive read for imperative engines (the engines subscribe to `change` themselves). */
export function reducedMotionQuery(): MediaQueryList | { matches: boolean; addEventListener: (type: string, listener: () => void) => void; removeEventListener: (type: string, listener: () => void) => void } {
  if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') return window.matchMedia(QUERY);
  return { matches: false, addEventListener: () => {}, removeEventListener: () => {} };
}
